module.exports = __webpack_public_path__ + "img/churchplusblueLogo.00ccedb3.png";